/**
 * Layout utility functions for blocks
 */

export interface LayoutConfig {
  width?: number | 'full';
}

/**
 * Convert layout width config to CSS max-width value
 * @param layout - Layout configuration object
 * @param defaultWidth - Default width when layout.width is not specified
 * @returns CSS max-width value as string
 */
export function getMaxWidth(
  layout?: LayoutConfig,
  defaultWidth?: string
): string {
  if (!layout?.width) {
    return defaultWidth || '800px';
  }

  if (layout.width === 'full') {
    return '100%';
  }

  return `${layout.width}px`;
}
